// @flow
import fetch from '../fetch';
import { apiEndpoint, getApiUrl } from './index';

export const updatePriceList = (): Promise =>
  fetch(apiEndpoint('v1/PriceList'), {
    baseURL: getApiUrl(),
  });
